module.exports = __webpack_public_path__ + "img/profile-book-cover.92680b81.jpg";